import { Component, OnInit, inject } from '@angular/core';
import { CookieDisclaimerService } from '../../services/cookie-disclaimer.service';
import { DefaultValuesService } from '../../services/defaultvalues.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { trigger, transition, style, animate } from '@angular/animations';


@Component({
    selector: 'app-cookie-disclaimer',
    templateUrl: './cookie-disclaimer.component.html',
    styleUrls: ['./cookie-disclaimer.component.less'],
    animations: [
        trigger('fadeTab', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('200ms ease', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class CookieDisclaimerComponent implements OnInit {

    public readonly COOKIE_DISCLAIMER_ABOUT_TEXT: string = "Cookies are small text files that can be used by websites to make a user's experience more efficient.<br/><br/>The law states that we can store cookies on your device if they are strictly necessary.";

    cookieExplanations: CookieDetail[] = [];
    cookie!: Cookie;
    cookieForm!: UntypedFormGroup;
    userUpn: string | undefined = undefined;
    animateTab = false;

    private readonly _cookieDisclaimerService = inject(CookieDisclaimerService);

    constructor(
        public defaults: DefaultValuesService,
        private dialogRef: MatDialogRef<CookieDisclaimerComponent>)
    { }

    ngOnInit(): void {
        const storageCookie = this._cookieDisclaimerService.getCookie(this.defaults.componentTool);
        const newCookie: Cookie = {
            technical: true,
            analytics: undefined
        }
        this.cookie = storageCookie ?? newCookie;

        this.initializeForm();
        this.userUpn = this.defaults.session?.UserUPN;
  }

    acceptAll(): void {
        this.cookie.technical = true;
        this.acceptCookieDisclaimer();
    }

    acceptCookieDisclaimer(): void {
        this._cookieDisclaimerService.setCookie(this.defaults.componentTool, this.cookie);

        if (this.cookie.analytics) {
            location.reload();
        }

        this.dialogRef.close();
    }

    onTabChange() {
        this.animateTab = true;
        setTimeout(() => {
            this.animateTab = false;
        }, 300);
    }

    private initializeForm(): void {
        this.cookieForm = new UntypedFormGroup({
            technical: new UntypedFormControl({ value: true, disabled: true }),
        });
    }
}
